import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import ButtonLink from '../ButtonLink';
import Image from '../Image';
import css from './Footer.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Footer = function Footer(_ref) {
  var cta = _ref.cta,
      imageDesktop = _ref.imageDesktop,
      imageMobile = _ref.imageMobile,
      Logo = _ref.logo,
      url = _ref.url;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageDesktop), {}, {
      className: [css.image, css.desktop]
    })), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageMobile), {}, {
      className: [css.image, css.mobile]
    })), /*#__PURE__*/_jsxs("div", {
      className: css.centered,
      children: [/*#__PURE__*/_jsx(Logo, {
        className: css.logo
      }), /*#__PURE__*/_jsx(ButtonLink, {
        white: true,
        href: url,
        children: cta
      })]
    })]
  });
};

Footer.propTypes = {
  cta: PropTypes.string.isRequired,
  imageDesktop: PropTypes.shape().isRequired,
  imageMobile: PropTypes.shape().isRequired,
  logo: PropTypes.elementType.isRequired,
  url: PropTypes.string.isRequired
};
export default Footer;